<template>
  <!-- Search form -->
  <form
    class="flex flex-col ms-auto gap-y-2"
    :class="customClass"
    @submit.capture.prevent="onSearch"
  >
    <slot name="label">
      <label class="text-body-large" for="search">
        {{ searchPlaceholder }}
      </label>
    </slot>

    <DrupalAutocomplete
      search-id="search"
      v-model="searchQuery"
      :disabled="!autocomplete"
      @submit="onSearch"
      v-slot="{ onInput, onKeydown, onFocus, onBlur }"
    >
      <InputGroup
        class="group border border-surface-700! rounded-md! hover:border-mbzuai-dark-navy-500! transition-all! flex items-stretch"
      >
        <InputText
          :value="searchQuery"
          :placeholder="searchPlaceholder"
          size="large"
          name="keys"
          type="text"
          class="border-none! border-r-0"
          id="search"
          autocomplete="off"
          ref="searchInput"
          @input="onInput"
          @keydown="onKeydown"
          @focus="onFocus"
          @blur="onBlur"
        />
        <InputGroupAddon class="border-transparent!">
          <Button
            type="submit"
            variant="link"
            severity="secondary"
            class="border-none!"
            aria-label="Submit"
            :disabled="!searchQuery.trim()"
          >
            <template #icon>
              <img
                src="/images/icons/search.svg"
                alt="Search Icon"
                class="w-4 h-4"
              />
            </template>
          </Button>
        </InputGroupAddon>
      </InputGroup>
    </DrupalAutocomplete>
  </form>
</template>

<script setup lang="ts">
import { useTemplateRef } from 'vue';

const searchInput = useTemplateRef('searchInput');
onMounted(async () => {
  if (!props.autofocus) return;
  await nextTick();
  searchInput.value?.$el?.focus();
});

const props = withDefaults(
  defineProps<{
    searchPlaceholder: string;
    customClass?: string;
    targetPath?: string;
    autofocus?: boolean;
    preserveSort?: boolean;
    autocomplete?: boolean;
    clearOnEmpty?: boolean;
  }>(),
  {
    searchPlaceholder: 'Search The Site',
    customClass: 'w-full lg:max-w-[420px]',
    targetPath: undefined,
    autofocus: true,
    preserveSort: false,
    autocomplete: true,
    clearOnEmpty: false,
  }
);

const { onSearch, searchQuery } = useDrupalSearch({
  targetPath: props.targetPath,
  preserveSort: props.preserveSort,
});

const route = useRoute();
watch(searchQuery, (val) => {
  if (props.clearOnEmpty && !val && route.query.keys) {
    onSearch();
  }
});
</script>
